module.exports = __webpack_public_path__ + "img/toolsItem07.99eb8edd.png";